import { CRUDMutations } from '@/utils/store-utilities'

const defaultItem = (item) => ({
  ...item,
})

export const state = () => ({
  items: [],
})

export const mutations = {
  ...CRUDMutations(defaultItem),
}

export const getters = {}

export const actions = {
  createDiscount({ commit }, item) {
    return this.$axios.$post('admin/discounts/create', { ...item }).then((response) => {
      commit('add', { ...response.data })
    })
  },
  duplicateDiscount({ commit }, item) {
    console.log(item)
    return this.$axios.$post(`admin/discounts/${item.target_id}/copy`, { ...item }).then((response) => {
      commit('add', { ...response.data })
    })
  },
  removeDiscount({ commit }, item) {
    return this.$axios.$delete(`admin/discounts/${item.id}`).then((response) => {
      if (response.data) {
        commit('remove', item)
      }
    })
  },
  updateDiscount({ commit }, item) {
    return this.$axios.$put(`admin/discounts/${item.id}`, { ...item }).then((response) => {
      commit('update', { ...response.data })
    })
  },
  fetchDiscounts({ commit }) {
    return this.$axios.$get('admin/discounts').then((response) => {
      commit('load', response.data)
    })
  },
  fetchDiscount({ commit }, id) {
    return this.$axios.$get(`admin/discounts/${id}`).then((response) => {
      return response.data
    })
  },
}
